import React from 'react';
import PropTypes from 'prop-types';
import { FILTER_PERIODS } from '../../constants';

/**
 * Date Range Picker Component
 * Allows selection of time period for filtering data
 * @param {Object} props - Component props
 * @param {string} props.period - Currently selected period
 * @param {Function} props.onPeriodChange - Period change handler
 * @param {string} [props.className] - Additional CSS classes
 */
const DateRangePicker = ({ period, onPeriodChange, className = '' }) => {
  const periods = [
    { value: FILTER_PERIODS.DAY, label: 'Today' },
    { value: FILTER_PERIODS.WEEK, label: 'This Week' },
    { value: FILTER_PERIODS.MONTH, label: 'This Month' },
    { value: FILTER_PERIODS.YEAR, label: 'This Year' },
    { value: FILTER_PERIODS.ALL, label: 'All Time' }
  ];

  return (
    <div className={`date-range-picker ${className}`}>
      <label className="filter-label">Time Period</label>
      <div className="period-buttons">
        {periods.map(({ value, label }) => (
          <button
            key={value}
            className={`period-button ${period === value ? 'active' : ''}`}
            onClick={() => onPeriodChange(value)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

DateRangePicker.propTypes = {
  period: PropTypes.string.isRequired,
  onPeriodChange: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default DateRangePicker;
